import { render, staticRenderFns } from "./EndorsementActivities.vue?vue&type=template&id=cd024c18"
import script from "./EndorsementActivities.vue?vue&type=script&lang=ts"
export * from "./EndorsementActivities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports